import { BackTop, Spin } from "antd";
import React, { useState } from "react";
import AppSection from "./AppSection/AppSection";
import ContactSection from "./ContactSection/ContactSection";
import Layout from "./Layout";
import MainSlide from "./MainSlide/MainSlide";
import { useRegistrationData } from "../../hooks/useRegistrationData";

const HomePage = () => {
  console.log("HomePage component is rendering.");
  const { isBusy, resStatus } = useRegistrationData();
  const [contactData, setContactData] = useState({});
  const [errorField, setErrorField] = useState([]);

  return (
    <Layout resStatus={resStatus}>
      <Spin spinning={isBusy}>
        <MainSlide resStatus={resStatus} />
        <AppSection resStatus={resStatus} />
        <ContactSection
          contactData={contactData}
          setContactData={setContactData}
          resStatus={resStatus}
          errorField={errorField}
          setErrorField={setErrorField}
        />
      </Spin>
      <BackTop />
    </Layout>
  );
};

export default HomePage;
